import dbsService from "@/services/dbs";
import store from "@/store";

// x-bks-sessionid必須
export const getDbsReservation = async () => {
  try {
    const resp = await dbsService.apiWithSessionIdWrapper(
      "GET",
      `dbs/reservation`
    );
    const reservationInfo = resp.data.reserve_info;

    // 予約情報に関するAPIレスポンスが他に散見するため、既存データにプッシュする形をとる
    const storeReservationData = store.getters["dbs/reservation"];
    if (storeReservationData == null) {
      store.commit("dbs/setReservation", reservationInfo);
    } else {
      store.commit("dbs/setReservation", {
        ...storeReservationData,
        ...reservationInfo,
      });
    }

    // 予約がある場合は、自転車情報をセット
    if (reservationInfo.status == "reserved") {
      store.commit("dbs/setCycle", reservationInfo.cycle_info);
    }
  } catch (err) {
    console.log('ERROR"" getDbsReservation()');
    throw err;
  }
};
